<script setup>
const props = defineProps({
  disabled: {
    type: Boolean
  }
})

const model = defineModel()
</script>

<template>
  <label class="inline-flex items-center cursor-pointer":title="props.disabled ? 'Coming in future release' : ''">
    <input :disabled="props.disabled" type="checkbox" id="email" name="email" v-model="model" class="sr-only peer" />
    <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#29476b] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#ff9d6e]" :class="{'after:bg-[#737373]': props.disabled, 'after:bg-white': !props.disabled}"></div>
  </label>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/components/ui/toggle.scss';


</style>
